import { useState } from 'react';

/**
 * Use KDialog hook
 */
function useKDialog() {
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    var handleClickOpen = function () {
        setOpen(true);
    };
    var handleClose = function () {
        setOpen(false);
    };
    return { open: open, handleClickOpen: handleClickOpen, handleClose: handleClose };
}

export { useKDialog as default };
//# sourceMappingURL=use-kdialog.js.map
